import { AUDIO_PLAY, AUDIO_STOP, AUDIO_LOAD, AUDIO_OPT_IN, AUTO_PLAY } from './audioManagerActions'
import { Map } from 'immutable'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'

const INITIAL_STATE = Map({
    state: Map(),
    optin: false,
    autoplay: !QueryParamUtils.isMediaAutoPlayDisabled(),
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AUDIO_PLAY:
        case AUDIO_STOP:
        case AUDIO_LOAD:
            return state.setIn(['state', action.name], action.type)
        case AUDIO_OPT_IN:
            return state.setIn(['optin'], true)
        case AUTO_PLAY:
            return state.set('autoplay', action.autoPlay)
        default:
            return state
    }
}
